import { USER_FEATURES_KEYS } from 'consts';

import { useGetOrganisationFeatureAccess } from './useGetOrganisationFeatureAccess';

/**
 * @deprecated use hook useUserCapability instead
 * This hook is deprecated and will be removed in the future.
 */
export const useTransactionsFeature = () =>
  useGetOrganisationFeatureAccess(USER_FEATURES_KEYS.transactions);
